// extracted by mini-css-extract-plugin
module.exports = {"l1fcr43o":"l1fcr43o","selected":"selected","beta":"beta"};